import { Program } from 'first-common/javaTypes'
import { useAsset } from 'first-common/AssetHelper';


export default function SeasonLogo({program, cmpYear}: { program: Program, cmpYear: number }) {
    const asset = useAsset(`img/season-logos/${program.toLowerCase()}/${cmpYear}.svg`);
    return <img src={asset} alt={`${program} ${cmpYear} Logo`} style={{height: '90px'}} />
}